import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CwtAuthStoreService } from '@cawita/core-front/auth';
import { filter, take } from 'rxjs/operators';
import { StayStore } from './stay.store';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';

@Injectable({ providedIn: 'root' })
export class PartnerInactiveGuard implements CanActivate {
    constructor(
        @Inject(CWT_APP_CONFIG) private appConfig: CwtAppConfig,
        private auth: CwtAuthStoreService,
        private store: StayStore,
        private router: Router
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const res = await this.store.state$.pipe(take(1), filter(s => s.initialized && !s.loading)).toPromise();
      if(res.activePartner || this.auth.isLoggedIn) return this.router.createUrlTree(this.appConfig.stay.redirectOnPartnerActive);
      return true;
    }
}
